<template>
    <span class="invoice-platform">
        <a v-if="invoicePlatform.href" :href="invoicePlatform.href" target="_blank">
            {{ invoicePlatform.label }}
        </a>
        <span v-else>{{ invoicePlatform.label }}</span>
    </span>
</template>

<script>
import { eInvoicePlatformInfo } from '@/assets/commonData/options';

export default {
    props: {
        platformID: {
            type: [Number, String],
            default: 0,
        },
    },
    computed: {
        invoicePlatform() {
            console.log(this.platformID);
            switch (this.platformID) {
            case 1:
            case 'EZPay':
                return eInvoicePlatformInfo.ezPay;
            case 2:
            case 'SunPay':
                return eInvoicePlatformInfo.sunPay;
            default:
                return eInvoicePlatformInfo.none;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.invoice-platform a {
    color: $main-color;
    text-decoration: none;
}
</style>
